<template>
  <b-row>
    <b-modal id="modal-main" ok-only ok-title="Add" centered size="lg" title="Add Equipment" :hide-footer="true">
      <AddEquipment @refresh="refreshData" />
    </b-modal>
    <b-modal id="modal-edit" ok-only ok-title="Add" centered size="lg" title="Edit Equipment" :hide-footer="true">
      <EditEquipment :equipment="equipmentData" @refresh="refreshData" />
    </b-modal>
    <b-col cols="12">
      <!-- <div class="d-flex justify-content-start">

        <b-button disabled variant="primary" class="my-1"
          style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
          {{ "Booked = " }} {{ this.booked }}
        </b-button>
        <b-col md="1" sm="8" class="my-1"> </b-col>

        <b-button disabled variant="primary" class="my-1"
          style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
          {{ "Available = " }} {{ this.available }}
        </b-button>
        <b-col md="1" sm="8" class="my-1"> </b-col>

        <b-button disabled variant="primary" class="my-1"
          style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
          {{ "Maintenance = " }} {{ this.maintenance }}
        </b-button>
        <b-col md="1" sm="8" class="my-1"> </b-col>

        <b-button disabled variant="primary" class="my-1"
          style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
          {{ "Broken = " }} {{ this.broken }}
        </b-button>
        <b-col md="1" sm="8" class="my-1"> </b-col>

        <b-button disabled variant="primary" class="my-1"
          style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
          {{ "Not Available = " }} {{ this.notAvailable }}
        </b-button>
      </div> -->

      <!-- Mobile Layout -->
<div class="d-flex flex-column d-md-none">
  <b-button disabled variant="primary" class="my-1 w-100"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Booked = " }} {{ this.booked }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Available = " }} {{ this.available }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Maintenance = " }} {{ this.maintenance }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Broken = " }} {{ this.broken }}
  </b-button>
  <b-button disabled variant="primary" class="my-1 w-100"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Not Available = " }} {{ this.notAvailable }}
  </b-button>
</div>

<!-- Desktop Layout -->
<div class="d-none d-md-flex justify-content-start">
  <b-button disabled variant="primary" class="my-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Booked = " }} {{ this.booked }}
  </b-button>
  <b-col md="1" sm="8" class="my-1"> </b-col>

  <b-button disabled variant="primary" class="my-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Available = " }} {{ this.available }}
  </b-button>
  <b-col md="1" sm="8" class="my-1"> </b-col>

  <b-button disabled variant="primary" class="my-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Maintenance = " }} {{ this.maintenance }}
  </b-button>
  <b-col md="1" sm="8" class="my-1"> </b-col>

  <b-button disabled variant="primary" class="my-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Broken = " }} {{ this.broken }}
  </b-button>
  <b-col md="1" sm="8" class="my-1"> </b-col>

  <b-button disabled variant="primary" class="my-1"
    style="background-color: transparent !important; color: #93bb3d !important; font-weight: bold !important;">
    {{ "Not Available = " }} {{ this.notAvailable }}
  </b-button>
</div>


      <div class="d-flex justify-content-end">
        <b-button variant="primary" v-b-modal.modal-main>
          <feather-icon icon="PlusIcon" class="mr-50" />
          Add Equipment
        </b-button>
      </div>
    </b-col>
    <b-col  cols="12" md="2" sm="1" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
      </b-form-group>
    </b-col>

    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredEquipmentList"
        :fields="fields" :sort-by.sync="sortBy"
  :sort-desc.sync="sortDesc"
  :sort-direction="sortDirection"
        @filtered="onFiltered">

        <!-- Equipment Code Filter -->
        <template #head(assetCode)="scope">
          <div class="d-flex flex-column">
            <span>Equipment Code</span>
            <b-form-input v-model="filters.assetCode" placeholder="Search Equipment Code" size="sm"
              @input="currentPage = 1" />
          </div>
        </template>

        <!-- Name Filter -->
        <template #head(name)="scope">
          <div class="d-flex flex-column">
            <span>Name</span>
            <b-form-input v-model="filters.name" placeholder="Search Name" size="sm" @input="currentPage = 1" />
          </div>
        </template>

        <!-- Purchase Date Filter -->
        <template #head(purchaseDate)="scope">
          <div class="d-flex flex-column">
            <span>Purchase Date</span>
            <DatePicker v-model="filters.purchaseDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="currentPage = 1" style="width: 100%;" size="sm" />
          </div>
        </template>

        <!-- Life End Date Filter -->
        <template #head(lifeEndDate)="scope">
          <div class="d-flex flex-column">
            <span>Life End Date</span>
            <DatePicker v-model="filters.lifeEndDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="currentPage = 1" style="width: 100%;" size="sm" />
          </div>
        </template>

        <!-- Maintenance Date Filter -->
        <template #head(maintainanceDate)="scope">
          <div class="d-flex flex-column">
            <span>Maintenance Date</span>
            <DatePicker v-model="filters.maintenanceDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="currentPage = 1" style="width: 100%;" size="sm" />
          </div>
        </template>

        <!-- Location Filter -->
        <template #head(location)="scope">
          <div class="d-flex flex-column">
            <span>Location</span>
            <b-form-input v-model="filters.location" placeholder="Search Location" size="sm" @input="currentPage = 1" />
          </div>
        </template>

        <!-- Status Filter -->
        <template #head(status)="scope">
          <div class="d-flex flex-column">
            <span>Status</span>
            <b-form-select v-model="filters.status" :options="statusOptions" size="sm" @change="currentPage = 1" />
          </div>
        </template>

        <template #cell(status)="data">
          <b-badge v-if="data.item.status === 1" variant="secondary"> Booked </b-badge>
          <b-badge v-else-if="data.item.status === 2" variant="primary">
            Available
          </b-badge>
          <b-badge v-else-if="data.item.status === 3" variant="info">
            Maintenance
          </b-badge>
          <b-badge v-else-if="data.item.status === 4" variant="warning"> Broken </b-badge>
          <b-badge v-else variant="danger"> Not Available </b-badge>
        </template>

        <template #cell(purchaseDate)="data">
          <span v-if="!data.item.purchaseDate"> - </span>
          <span v-else> {{ formatDate(data.item.purchaseDate) }} </span>
        </template>
        <template #cell(maintainanceDate)="data">
          <span v-if="!data.item.maintainanceDate"> - </span>
          <span v-else> {{ formatDate(data.item.maintainanceDate) }} </span>
        </template>
        <template #cell(lifeEndDate)="data">
          <span v-if="!data.item.lifeEndDate"> - </span>
          <span v-else> {{ formatDate(data.item.lifeEndDate) }} </span>
        </template>

        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item v-b-modal.modal-edit @click="getEquipmentData(data.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="removeEquipment(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <p>Total Records: {{ this.totalRecords }}</p>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";

import AddEquipment from "./AddEquipment.vue";
import EditEquipment from "./EditEquipment.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    AddEquipment,
    EditEquipment,
    DatePicker
  },
  data() {
    return {
      equipmentData: [],
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
        sortBy: "assetCode", // Default sorting column
    sortDesc: false, // Default ascending order
    sortDirection: "asc",
      filter: null,
      booked: 0,
      available: 0,
      maintenance: 0,
      broken: 0,
      notAvailable: 0,
      totalRecords: 0,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
      { key: "assetCode", label: "Equipment Code", sortable: true },
      { key: "name", label: "Name", sortable: true },
      { key: "purchaseDate", label: "Purchase Date", sortable: true },
      { key: "lifeEndDate", label: "Life End Date", sortable: true },
      { key: "maintainanceDate", label: "Maintenance Date", sortable: true },
      { key: "location", label: "Location", sortable: true },
      { key: "status", label: "Status", sortable: true },
      { key: "actions", label: "Actions" }, // Not sortable
    ],
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      filters: {
        assetCode: "", // Equipment Code
        name: "", // Name
        purchaseDateRange: [null, null], // Purchase Date
        lifeEndDateRange: [null, null], // Life End Date
        maintenanceDateRange: [null, null], // Maintenance Date
        location: "", // Location
        status: null, // Status
      },
      statusOptions: [
        { value: null, text: "All" },
        { value: 1, text: "Booked" },
        { value: 2, text: "Available" },
        { value: 3, text: "Maintenance" },
        { value: 4, text: "Broken" },
        { value: 5, text: "Not Available" },
      ],
    };
  },
  computed: {
    filteredEquipmentList() {
      return this.equipmentList.filter((item) => {
        const matchesAssetCode =
          !this.filters.assetCode ||
          (item.assetCode &&
            item.assetCode
              .toLowerCase()
              .includes(this.filters.assetCode.toLowerCase()));

        const matchesName =
          !this.filters.name ||
          (item.name &&
            item.name.toLowerCase().includes(this.filters.name.toLowerCase()));

        const matchesPurchaseDate =
          !this.filters.purchaseDateRange[0] ||
          !this.filters.purchaseDateRange[1] ||
          (new Date(item.purchaseDate) >=
            new Date(this.filters.purchaseDateRange[0]) &&
            new Date(item.purchaseDate) <=
            new Date(this.filters.purchaseDateRange[1]));

        const matchesLifeEndDate =
          !this.filters.lifeEndDateRange[0] ||
          !this.filters.lifeEndDateRange[1] ||
          (new Date(item.lifeEndDate) >=
            new Date(this.filters.lifeEndDateRange[0]) &&
            new Date(item.lifeEndDate) <=
            new Date(this.filters.lifeEndDateRange[1]));

        const matchesMaintenanceDate =
          !this.filters.maintenanceDateRange[0] ||
          !this.filters.maintenanceDateRange[1] ||
          (new Date(item.maintainanceDate) >=
            new Date(this.filters.maintenanceDateRange[0]) &&
            new Date(item.maintainanceDate) <=
            new Date(this.filters.maintenanceDateRange[1]));

        const matchesLocation =
          !this.filters.location ||
          (item.location &&
            item.location
              .toLowerCase()
              .includes(this.filters.location.toLowerCase()));

        const matchesStatus =
          this.filters.status === null || item.status === this.filters.status;

        return (
          matchesAssetCode &&
          matchesName &&
          matchesPurchaseDate &&
          matchesLifeEndDate &&
          matchesMaintenanceDate &&
          matchesLocation &&
          matchesStatus
        );
      });
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("equipmentModule", {
      equipmentList: "equipments",
      loading: "loading",
    }),
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.equipmentList.length;
  },
  methods: {
    clearFilters() {
      this.filters = {
        assetCode: "", // Reset Equipment Code
        name: "", // Reset Name
        purchaseDateRange: [null, null], // Reset Purchase Date
        lifeEndDateRange: [null, null], // Reset Life End Date
        maintenanceDateRange: [null, null], // Reset Maintenance Date
        location: "", // Reset Location
        status: null, // Reset Status
      };
      this.currentPage = 1; // Reset pagination
    },
    formatDate(inputDateStr) {
      const dateObj = new Date(inputDateStr);
      const formattedDateStr = dateObj.toLocaleDateString();
      return formattedDateStr;
    },
    getEquipmentData(data) {
      this.equipmentData = data;
    },
    refreshData() {
      this.getEquipmentListAction();
      this.getEquipmentStatusCount();
      if (this.equipmentData != null || this.equipmentData != null)
        this.updateEquipmentStatus(this.equipmentData.status);
    },

    async updateEquipmentStatus(status) {
      if (status > 0) {
        switch (status) {
          case '1':
            this.booked++;
            break;
          case '2':
            this.available++;
            break;
          case '3':
            this.maintenance++;
            break;
          case '4':
            this.broken++;
            break;
          case '5':
            this.notAvailable++;
            break;
          default:
            console.log("Unknown status:", status);
        }
      }
    },
    removeEquipment(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeEquipmentAction(id).then(() => {
            this.getEquipmentStatusCount();
            this.$swal({
              title: "Deleted!",
              text: "This equipment has been deleted.",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }).catch((error) => {
            this.$swal({
              title: "Error!",
              text: " Failed! " + error.response.data.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Your equipment is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },

    async getEquipmentStatusCount() {
      const counts = {
        booked: 0,
        available: 0,
        maintenance: 0,
        broken: 0,
        notAvailable: 0,
      };
      this.totalRecords = this.equipmentList.length;
      this.equipmentList.forEach((equipment) => {
        if (!equipment.isActive) return;
        switch (equipment.status) {
          case 1:
            counts.booked++;
            break;
          case 2:
            counts.available++;
            break;
          case 3:
            counts.maintenance++;
            break;
          case 4:
            counts.broken++;
            break;
          case 5:
            counts.notAvailable++;
            break;
          default:
            console.log("Unknown status:", equipment.status);
        }
      });
      this.booked = counts.booked;
      this.available = counts.available;
      this.maintenance = counts.maintenance;
      this.broken = counts.broken;
      this.notAvailable = counts.notAvailable;
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    ...mapActions("equipmentModule", ["getEquipmentListAction", "removeEquipmentAction"]),
  },
  async mounted() {
    await this.getEquipmentListAction()
      .then(() => {
        this.totalRows = this.equipmentList.length;

      })
      .catch((response) => {
        console.log(response);
      });
    await this.getEquipmentStatusCount();
    this.totalRecords = this.totalRows;
  },
};
</script>
